import { SmileOutlined } from '@ant-design/icons';
import { Result } from 'antd';
import { memo } from 'react';
import { useParams } from 'react-router-dom';
import ChatLayout from '../components/ChatLayout';

const Home = () => {
  const { conversationId } = useParams();

  return conversationId ? (
    <ChatLayout />
  ) : (
    <Result
      icon={<SmileOutlined />}
      title="Hello, please select a conversation or start new chat!"
      style={{
        height: '93vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    />
  );
};

export default memo(Home);
